import { PLATFORM_NAMES } from '@/core/platform'
import { type MessageFormHost, need, startMessageForm } from './message-form'
import { type Attached, attachedFromQuery } from './support-links'
import { MessageSource } from './support-request'

/* The support form on public/pagalba.html: the markup is in the page; the form itself is in message-form.ts. This
   shows what the app attached and starts the form with it. */

/** "0.1.0+a6283e0, iPhone / iPad"; either part may be missing. */
export function appLabel(attached: Attached): string {
  const platform = attached.platform === null ? null : PLATFORM_NAMES[attached.platform]
  return [attached.version, platform].filter((part) => part !== null).join(', ')
}

/** Shows what the app attached (each with „Nesiųsti“) and returns what is still attached when the form is sent. */
function showAttached(form: HTMLFormElement, attached: Attached): () => Attached {
  let current = attached
  const box = need(form, '[data-role="attached"]', HTMLElement)
  const codeChip = need(form, '[data-role="attached-code"]', HTMLElement)
  const appChip = need(form, '[data-role="attached-app"]', HTMLElement)
  const refresh = () => {
    codeChip.hidden = current.code === null
    appChip.hidden = current.version === null && current.platform === null
    box.hidden = codeChip.hidden && appChip.hidden
  }
  need(codeChip, '[data-role="value"]', HTMLElement).textContent = current.code
  need(appChip, '[data-role="value"]', HTMLElement).textContent = appLabel(current)
  need(codeChip, '[data-action="clear-code"]', HTMLButtonElement).addEventListener('click', () => {
    current = { ...current, code: null }
    refresh()
  })
  need(appChip, '[data-action="clear-app"]', HTMLButtonElement).addEventListener('click', () => {
    current = { ...current, version: null, platform: null }
    refresh()
  })
  refresh()
  return () => current
}

export function startSupportPage(host: MessageFormHost): void {
  const form = need(host.doc, '[data-role="form"]', HTMLFormElement)
  startMessageForm(host, MessageSource.support, showAttached(form, attachedFromQuery(host.search)))
}
